















import { Filter } from '@empathy/search-types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Store } from 'vuex';
import { EVENTS } from '../../../bus/events.const';
import { RootStoreState } from '../../../store';
import AddClassToSlot from '../add-class-to-slot';
import { CheckBoxFilter } from '../facet';

@Component({
  components: {
    CheckBoxFilter,
    AddClassToSlot
  }
})
export default class FallbackFilter extends Vue {

  @Prop({ required: true })
  filter: Filter;

  @Prop({ default: 6 })
  maxResultsToShow: number;

  mounted() {
    this.$x.emit(EVENTS.GetFallbackFilterResults, this.filter);
  }

  get results() {
    const fallbackFiltersResults = (this.$store as Store<RootStoreState>).state.noResults.fallbackFiltersResults;
    return (fallbackFiltersResults[this.filter.id] || []).slice(0, this.maxResultsToShow);
  }

}
